import React from "react";
import "./about.css";
import profileImage from "../../images/profile/johandry.jpeg"
import profileImgen from "../../images/profile/torre-david.jpg"

const About = ()=> {
  return (
    <section id="about" className="about" style={{ backgroundImage: `url(${profileImgen})` }}>
      <div className="about-content" >
        <div className="container-img">
          <img src={profileImage} alt="Johandry Perez" className="about-img" />
        </div>
        
        <div>
          <h2>Johandry A Pérez Sánchez</h2>
          <p>
          Front-End Developer con experiencia en el desarrollo de interfaces responsivas, optimización web y buenas prácticas con HTML, CSS, JavaScript, React y SEO.
          También cuento con habilidades como QA Tester, enfocadas en pruebas funcionales, reporte de bugs y análisis de requisitos.
          Familiarizado con herramientas como Jira, Trello y Figma.
          Comprometido con la calidad del software, el trabajo en equipo y la mejora constante.          </p>
        </div>
      </div>
    </section>
  );
}

export default About;